import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { IPickupAccountDetail, IPickupAccountForm } from "interfaces";
import { PickupAccountForm } from "./components";

export const EditPickupAccount: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate, isLoading: isUpdating } = useUpdate();
  const navigate = useNavigate();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IPickupAccountDetail>({
    resource: "pickup/accounts",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });


	const onSubmit = (values: IPickupAccountForm) => {
    const submitValues = { ...values };
		const id = params?.id;
		if (id) {
			mutate(
				{
					resource: "pickup/accounts",
					id: id,
					meta: {
						ignoreResourceWrapper: true,
					},
					values: {
						...submitValues,
					},
				},
				{
					onSuccess: () => {
						toast.success("Edit successfully");
						navigate(`/pickup/accounts/${id}`);
					},
				}
			);	
		}
  };

  const pickupAccountDetail = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Pickup Account" />
      {pickupAccountDetail ? (
        <PickupAccountForm
          defaultData={pickupAccountDetail}
          id={params?.id}
					onSubmit={onSubmit}
        />
      ) : (
        <></>
      )}
      {((isFetching && isPreviousData) || isUpdating) ? <FullScreenLoading /> : <></>}
    </div>
  );
};
